import { createNamespacer, createReducer } from "../utils/reducers";

const namespacer = createNamespacer("LEAD");

const initialState = {
  providerLeadCount: 0,
  providerLeadIndicator: false,
  providerLeadRefresh: false,
  plannerLeadCount: 0,
  plannerLeadIndicator: false,
  plannerLeadRefresh: false,
};

const handlers = {
  [namespacer("INITIALIZE_PROVIDER_LEAD_COUNT")]: (state: any, action: any) => {
    return {
      ...state,
      providerLeadCount:  action.payload?.count,
      providerLeadIndicator: false,
    };
  },
  [namespacer("SET_PROVIDER_LEAD_COUNT")]: (state: any, action: any) => {
    return {
      ...state,
      providerLeadCount:  action.payload?.count,
      providerLeadIndicator: action.payload?.count > state.providerLeadCount ? true : state.providerLeadIndicator,
    };
  },
  [namespacer("SET_PROVIDER_LEAD_INDICATOR")]: (state: any, action: any) => {
    return {
      ...state,
      providerLeadIndicator: action.payload?.value,
    };
  },
  [namespacer("REFRESH_PROVIDER_LEAD_PAGE")]: (state: any, action: any) => {
    return {
      ...state,
      providerLeadRefresh: state.providerLeadIndicator ? action.payload?.value : false,
    };
  },

  [namespacer("INITIALIZE_PLANNER_LEAD_COUNT")]: (state: any, action: any) => {
    return {
      ...state,
      plannerLeadCount:  action.payload?.count,
      plannerLeadIndicator: false,
    };
  },
  [namespacer("SET_PLANNER_LEAD_COUNT")]: (state: any, action: any) => {
    return {
      ...state,
      plannerLeadCount:  action.payload?.count,
      plannerLeadIndicator: action.payload?.count > state.plannerLeadCount ? true : state.plannerLeadIndicator
    };
  },

  [namespacer("SET_PLANNER_LEAD_INDICATOR")]: (state: any, action: any) => {
    return {
      ...state,
      plannerLeadIndicator: action.payload?.value,
    };
  },
  [namespacer("REFRESH_PLANNER_LEAD_PAGE")]: (state: any, action: any) => {
    return {
      ...state,
      plannerLeadRefresh: state.plannerLeadIndicator ? action.payload?.value : false,
    };
  },
};

const search = createReducer(initialState, handlers, ["LEAD"]);

export default search;
